export default {
	title: 'Manejo de Advertencia',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa',
		requiredError: 'El campo obligatorio no puede estar vacío'
	},
	buttons: {
		add: 'Añadir',
		batchDelete: 'Eliminación por Lote',
		edit: 'Editar',
		delete: 'Eliminar',
		export: 'Exportar',
		exportAll: 'Exportar Todo',
		exportSelected: 'Export Selected'
	},
	table: {
		warnTitle: 'Título de Advertencia',
		projName: 'Nombre del Proyecto',
		deviceName: 'Nombre del Dispositivo',
		pointName: 'Nombre del Punto',
		orgName: 'Organización',
		warnLevel: 'Nivel de Advertencia',
		warnTime: 'Tiempo de Advertencia',
		featureValue: 'Valor Característico',
		content: 'Contenido',
		handleAction: 'Acción de Manejo',
		reviewResult: 'Resultado de Revisión',
		correct: 'Correcto',
		incorrect: 'Incorrecto',
		handler: 'Manejador',
		handleTime: 'Tiempo de Manejo',
		action: 'Acción'
	},
	form: {
		placeholder: {
			projName: 'Nombre del Proyecto',
			deviceName: 'Nombre del Dispositivo',
			pointName: 'Nombre del Punto',
			orgId: 'Organización',
			startTime: 'Tiempo de Inicio',
			endTime: 'Tiempo de Fin'
		},
		label: {
			gearName: 'Nombre del Engranaje',
			gearBrand: 'Marca del Engranaje',
			bpfo: 'Frecuencia Característica de Falla de Pista Exterior',
			bpfi: 'Frecuencia Característica de Falla de Pista Interior',
			bsf: 'Frecuencia Característica de Falla de Elemento Rodante',
			ftf: 'Frecuencia Característica de Falla de Jaula'
		}
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula'
	},
	dialog: {
		add: 'Añadir',
		update: 'Editar'
	}
}
